const commentsData = [
  {
    name: '电影爱好者小王',
    date: '2026-07-30',
    content: '悟空影视真的太棒了！片库齐全，画质清晰，关键是完全免费。之前在其他平台看个电影要等半天广告，悟空影视即点即播的体验简直爽到飞起。强烈推荐给所有影迷朋友！',
    rating: 5,
  },
  {
    name: '摄影师大刘',
    date: '2026-07-28',
    content: '作为一个对画质有执念的人，悟空影视的4K超清画质让我非常惊喜。色彩还原准确，暗部细节保留得很好，大屏幕观看体验完全不输付费平台。动作片的爆炸场面和科幻片的特效细节都表现得很到位。',
    rating: 5,
  },
  {
    name: '剧荒拯救者',
    date: '2026-07-26',
    content: '暑假在家无聊刷到了悟空影视，一口气把悬疑片专题里的好几部都看完了。更新速度很快，新上映的大片过不了多久就能看到高清版。现在每天打开悟空影视看看有没有上新已经成了我的习惯。',
    rating: 4,
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1200px] mx-auto">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-8 h-8 flex items-center justify-center">
            <i className="ri-chat-3-line text-2xl text-primary-500"></i>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-100 font-bold">
            用户影评
          </h2>
        </div>
        <p className="text-sm text-foreground-400 mb-8 md:mb-10 ml-11">
          听听影迷们对悟空影视的真实评价
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {commentsData.map((comment, idx) => (
            <div
              key={idx}
              className="p-5 rounded-lg bg-background-50 border border-background-200/60"
            >
              <div className="flex items-center gap-1 mb-3">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={`text-xs ${i < comment.rating ? 'ri-star-fill text-primary-400' : 'ri-star-line text-foreground-600'}`}
                  ></i>
                ))}
              </div>
              <p className="text-xs text-foreground-400 leading-relaxed mb-4">
                &ldquo;{comment.content}&rdquo;
              </p>
              <div className="flex items-center gap-3 pt-3 border-t border-background-200/60">
                <div className="w-8 h-8 rounded-full bg-primary-500/20 flex items-center justify-center">
                  <span className="text-xs text-primary-400 font-semibold">
                    {comment.name.charAt(0)}
                  </span>
                </div>
                <div>
                  <p className="text-xs font-semibold text-foreground-300">{comment.name}</p>
                  <p className="text-[10px] text-foreground-600">{comment.date}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}